// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'babel-polyfill';
import iView from 'iview';
//import globalcomponents from '@/components/globalcomponents' //全局业务组件，实时编译时如vue.templete,需要引用全局组件
import 'iview/dist/styles/iview.css';
import nicescroll from "jquery.nicescroll";
import global from './assets/util/Global.vue'
import VueResource from 'vue-resource';
import XLSX from 'xlsx';
import AMap  from 'vue-amap';
Vue.use(require('vue-cookies'))
// vuex
import store from './store' 
import _global from './assets/util/Global.vue'
//解决路由采用异步加载时，在IE11下报Promise为定义错误 
window.Promise = Promise;
Vue.use(AMap);
AMap.initAMapApiLoader({
  key:'6604bc505899bae443005faa55c0e99c',
  plugin: ['AMap.Geolocation','AMap.Geocoder']
})
Vue.use(global)
Vue.use(ElementUI)
Vue.use(iView)
Vue.use(VueResource) 
Vue.use(XLSX) 
//Vue.use(globalcomponents)
window._vue = new Vue();
Vue.config.productionTip = false

// 兼容fetch请求ie8
require('es6-promise').polyfill();
router.afterEach((to, from, next) => {
  iView.LoadingBar.finish();
});



/* eslint-disable no-new */
var vm=new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})

Vue.prototype.GLOBAL = _global//挂载到Vue实例上面


// WEBPACK FOOTER //
// ./src/main.js